// extracted by mini-css-extract-plugin
export var brand = "_29-9";
export var compact = "_29-6";
export var extraSmall = "_29-7";
export var icon = "_29-0";
export var large = "_29-4";
export var light = "_29-1";
export var medium = "_29-5";
export var outline = "_29-b";
export var primaryDark = "_29-a";
export var primaryLight = "_29-8";
export var primaryModern = "_29-c";
export var success = "_29-2";
export var successSolid = "_29-3";